import {useCallback} from 'react'
import type {EstablishedAhpSession} from '@github-ui/ahp-session-client/contracts'

import {useOptionalPersistentAgentsChat, usePersistentAgentsChatSession} from './PersistentAgentsChatHost'

export function useRoutedTaskHandoff(taskId: string | undefined) {
  const adoptExternalSession = useOptionalPersistentAgentsChat()?.adoptExternalSession
  const persistentChat = usePersistentAgentsChatSession()
  const persistentInstanceKey = persistentChat?.instanceKey
  const isProvisioningThisTask = persistentChat?.provisioningTaskId === taskId
  const externallyProvisioned = isProvisioningThisTask && persistentChat?.externallyProvisioned === true
  const hostOwnsEstablishment = isProvisioningThisTask && !externallyProvisioned
  const establishedSessionPending = hostOwnsEstablishment && persistentChat?.establishedSessionPending
  const showOptimisticTurn = isProvisioningThisTask && (externallyProvisioned || establishedSessionPending)
  const handleEstablishedAhpSession = useCallback(
    (session: EstablishedAhpSession) => {
      if (adoptExternalSession && externallyProvisioned && persistentInstanceKey) {
        adoptExternalSession(persistentInstanceKey, session)
      }
    },
    [adoptExternalSession, externallyProvisioned, persistentInstanceKey],
  )

  return {
    persistentChat,
    isProvisioningThisTask,
    externallyProvisioned,
    hostOwnsEstablishment,
    establishedSessionPending,
    showOptimisticTurn,
    handleEstablishedAhpSession,
  }
}
